module.exports = __webpack_public_path__ + "images/facilitypage/placeholder.png";